import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'replacePicture' })
export class ReplacePicturePipe implements PipeTransform {
  transform(name: string, path: string, language = 'en-CH'): string {
    return `${path}/${language}-${name}.png`;
  }
}
